import createAPI from '../axios'
//import { config } from 'vue/types/umd';

//工作量相关API

const gradesManagement = {
    gradeSettings: {
        list: config => createAPI('/skillRecognition/cjsz/list', 'post', config),
        initOption: config => createAPI('/skillRecognition/cjsz/initOption', 'post', config),
        edit: config => createAPI('/skillRecognition/cjsz/edit', 'post', config),

    },
    scoreRegistration: {
        list: config => createAPI('/skillRecognition/cjdj/list', 'post', config),
        scorelist: config => createAPI('/skillRecognition/cjdj/scorelist', 'post', config),
        save: config => createAPI('/skillRecognition/cjdj/save', 'post', config),
        drkscj: config => createAPI('/skillRecognition/cjdj/drkscj', 'post', config),

    },
    transcripts: {
        list: config => createAPI('/skillRecognition/cjd/list', 'post', config),
        initOption: config => createAPI('/skillRecognition/cjd/initOption', 'post', config),
        batchExport: config => createAPI('/skillRecognition/cjd/batchExport', 'post', config),

    },
};


export default gradesManagement;



// WEBPACK FOOTER //
// ./src/api/modules/gradesManagement.js